import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Balls = styled.img`
  animation: ${rotate} 20s linear infinite;
  bottom: -70px;
  position: absolute;
  right: -115px;
  width: 290px;
  z-index: -1;
`;
Balls.displayName = 'Balls';

export const Container = styled.section`
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  min-width: 250px;
  max-width: 650px;
  position: relative;
`;
Container.displayName = 'Container';

export const Logo = styled.img`
  bottom: -24px;
  position: absolute;
  width: 50px;
`;
Logo.displayName = 'Logo';

export const Time = styled.div`
  align-items: center;
  background: #000;
  border: 10px solid;
  border-image-slice: 1;
  border-image-source: linear-gradient(
    90deg,
    rgba(249, 5, 30, 1) 0%,
    rgba(224, 188, 99, 1) 36%,
    rgba(224, 188, 99, 1) 65%,
    rgba(249, 5, 30, 1) 100%
  );
  color: #f9051e;
  display: flex;
  font-family: 'TheGrefg', system-ui;
  font-size: 100px;
  height: 162px;
  justify-content: center;
  letter-spacing: 1px;
  text-decoration: inherit;
  width: 423px;
`;
Time.displayName = 'Time';

export const TimeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
TimeContainer.displayName = 'TimeContainer';

export const Title = styled.div`
  color: #fff;
  font-size: 36px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  letter-spacing: 1px;
  padding: 12px 8px 12px;
  text-shadow: 2px 2px #f9051e, -1px 2px #f9051e, 2px -1px #f9051e,
    -2px -1px #f9051e, 2px 1px 3px #555;
  white-space: pre-wrap;
`;
Title.displayName = 'Title';
